module.exports = __webpack_public_path__ + "static/img/10.4ca3c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10.png
// module id = 3AJl
// module chunks = 1